import { render } from "./indexClient.vue?vue&type=template&id=e53c7e2a"
import script from "./indexClient.vue?vue&type=script&lang=js"
export * from "./indexClient.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__